/*
 * theme-collection.js — Decoupled Collection-specific modules from theme.js
 * Modules: theme.PriceRange, theme.CollectionHeader, theme.CollectionSidebar, theme.Collection
 */
(function() {
  'use strict';
  window.theme = window.theme || {};

 if (typeof window.noUiSlider === 'undefined') {
  throw new Error('theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js');
 }

 theme.PriceRange = (function() {
  var defaultStep = 10;
  var selectors = {
   priceRange: '.price-range',
   priceRangeSlider: '.price-range__slider',
   priceRangeInputMin: '.price-range__input-min',
   priceRangeInputMax: '.price-range__input-max',
   priceRangeDisplayMin: '.price-range__display-min',
   priceRangeDisplayMax: '.price-range__display-max',
  };

  function PriceRange(container, { onChange, onUpdate, ...sliderOptions } = {}) {
   this.container = container;
   this.onChange = onChange;
   this.onUpdate = onUpdate;
   this.sliderOptions = sliderOptions || {};

   return this.init();
  }

  PriceRange.prototype = Object.assign({}, PriceRange.prototype, {
   init: function() {
    if (!this.container.classList.contains('price-range')) {
     throw new Error('You must instantiate PriceRange with a valid container')
    }

    this.formEl = this.container.closest('form');
    this.sliderEl = this.container.querySelector(selectors.priceRangeSlider);
    this.inputMinEl = this.container.querySelector(selectors.priceRangeInputMin);
    this.inputMaxEl = this.container.querySelector(selectors.priceRangeInputMax);
    this.displayMinEl = this.container.querySelector(selectors.priceRangeDisplayMin);
    this.displayMaxEl = this.container.querySelector(selectors.priceRangeDisplayMax);

    this.minRange = parseFloat(this.container.dataset.min) || 0;
    this.minValue = parseFloat(this.container.dataset.minValue) || 0;
    this.maxRange = parseFloat(this.container.dataset.max) || 100;
    this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange;

    return this.createPriceRange();
   },

   createPriceRange: function() {
    if (this.sliderEl && this.sliderEl.noUiSlider && typeof this.sliderEl.noUiSlider.destroy === 'function') {
     this.sliderEl.noUiSlider.destroy();
    }

    var slider = noUiSlider.create(this.sliderEl, {
     connect: true,
     step: defaultStep,
     ...this.sliderOptions,
     // Do not allow overriding these options
     start: [this.minValue, this.maxValue],
     range: {
      min: this.minRange,
      max: this.maxRange,
     },
    });

    slider.on('update', values => {
     this.displayMinEl.innerHTML = theme.Currency.formatMoney(
      values[0],
      theme.settings.moneyFormat,
     );
     this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
      values[1],
      theme.settings.moneyFormat,
     );

     if (this.onUpdate) {
      this.onUpdate(values);
     }
    });

    slider.on('change', values => {
     this.inputMinEl.value = values[0];
     this.inputMaxEl.value = values[1];

     if (this.onChange) {
      const formData = new FormData(this.formEl);
      this.onChange(formData);
     }
    });

    return slider;
   },
  });

  return PriceRange;
 })();


 theme.CollectionHeader = (function() {
  var hasLoadedBefore = false;

  function CollectionHeader(container) {
   this.namespace = '.collection-header';

   var heroImageContainer = container.querySelector('.collection-hero');
   if (heroImageContainer) {
    if (hasLoadedBefore) {
     this.checkIfNeedReload();
    }
    heroImageContainer.classList.remove('loading', 'loading--delayed');
    heroImageContainer.classList.add('loaded');
   } else if (theme.settings.overlayHeader) {
    theme.headerNav.disableOverlayHeader();
   }

   hasLoadedBefore = true;
  }

  CollectionHeader.prototype = Object.assign({}, CollectionHeader.prototype, {
   // A liquid variable in the header needs a full page refresh
   // if the collection header hero image setting is enabled
   // and the header is set to sticky. Only necessary in the editor.
   checkIfNeedReload: function() {
    if (!Shopify.designMode) {
     return;
    }

    if (theme.settings.overlayHeader) {
     var header = document.querySelector('.header-wrapper');
     if (!header.classList.contains('header-wrapper--overlay')) {
      location.reload();
     }
    }
   }
  });

  return CollectionHeader;
 })();

 theme.CollectionSidebar = (function() {
  var drawerStyle = false;
  var selectors = {
   sidebar: '#CollectionSidebar',
  };

  function CollectionSidebar(container) {
   this.container = container.querySelector(selectors.sidebar);
  }

  CollectionSidebar.prototype = Object.assign({}, CollectionSidebar.prototype, {
   init: function() {
    // Do not load when no sidebar exists
    if (!this.container) {
     return;
    }

    this.onUnload();

    drawerStyle = this.container.dataset.style === 'drawer';
    theme.FilterDrawer = new theme.Drawers('FilterDrawer', 'collection-filters', true);
   },

   forceReload: function() {
    this.init();
   },

   onSelect: function() {
    if (theme.FilterDrawer) {
     if (!drawerStyle) {
      theme.FilterDrawer.close();
      return;
     }

     if (drawerStyle || theme.config.bpSmall) {
      theme.FilterDrawer.open();
     }
    }
   },

   onDeselect: function() {
    if (theme.FilterDrawer) {
     theme.FilterDrawer.close();
    }
   },

   onUnload: function() {
    if (theme.FilterDrawer) {
     theme.FilterDrawer.close();
    }
   }
  });

  return CollectionSidebar;
 })();

 theme.Collection = (function() {
  var isAnimating = false;

  var selectors = {
   sortSelect: '#SortBy',

   colorSwatchImage: '.grid-product__color-image',
   colorSwatch: '.color-swatch--with-image',

   collectionGrid: '.collection-grid__wrapper',
   trigger: '.collapsible-trigger',
   sidebar: '#CollectionSidebar',
   filterSidebar: '.collapsible-content--sidebar',
   activeTagList: '.tag-list--active-tags',
   tags: '.tag-list input',
   activeTags: '.tag-list a',
   tagsForm: '.filter-form',
   filters: '.collection-filter',
   priceRange: '.price-range',
  };

  var classes = {
   activeTag: 'tag--active',
   removeTagParent: 'tag--remove',
   filterSidebar: 'collapsible-content--sidebar',
   isOpen: 'is-open',
  };

  function Collection(container) {
   this.container = container;
   this.sectionId = container.getAttribute('data-section-id');
   this.namespace = '.collection-' + this.sectionId;
   this.sidebar = new theme.CollectionSidebar(container);
   this.context = container.getAttribute('data-context');
   this.ajaxRenderer = new theme.AjaxRenderer({
    sections: [
     {
      sectionId: this.sectionId,
      nodeId: 'CollectionAjaxContent',
     },
    ],
    onReplace: this.onReplaceAjaxContent.bind(this),
   });

   this.init();
  }

  Collection.prototype = Object.assign({}, Collection.prototype, {
   init: function() {

    /* Prevent extra JS from running for featured collection on a collection template */
    if (this.context && this.context === 'featured-collection') {
     this.colorSwatchHovering();
    } else {
     this.initSort();
     this.colorSwatchHovering();
     this.initFilters();
     this.initPriceRange();
     this.sidebar.init();
    }
   },

   initSort: function() {
    this.sortSelect = document.querySelector(selectors.sortSelect);

    if (this.sortSelect) {
     this.defaultSort = this.getDefaultSortValue();
     this.sortSelect.on('change' + this.namespace, this.onSortChange.bind(this));
    }
   },

   getSortValue: function() {
    return this.sortSelect.value || this.defaultSort;
   },

   getDefaultSortValue: function() {
    return this.sortSelect.getAttribute('data-default-sortby');
   },

   onSortChange: function() {
    this.queryParams = new URLSearchParams(window.location.search);

    this.queryParams.set('sort_by', this.getSortValue());
    this.queryParams.delete('page'); // Delete if it exists

    window.location.search = this.queryParams.toString();
   },

   colorSwatchHovering: function() {
    var colorImages = this.container.querySelectorAll(selectors.colorSwatchImage);
    if (!colorImages.length) {
     return;
    }

    this.container.querySelectorAll(selectors.colorSwatch).forEach(swatch => {
     swatch.addEventListener('mouseenter', () => {
      var id = swatch.dataset.variantId;
      var image = swatch.dataset.variantImage;
      var el = this.container.querySelector('.grid-product__color-image--' + id);
      el.style.backgroundImage = 'url(' + image + ')';
      el.classList.add('is-active');
     });
     swatch.addEventListener('mouseleave', () => {
      var id = swatch.dataset.variantId;
      this.container.querySelector('.grid-product__color-image--' + id).classList.remove('is-active');
     });
    });
   },

   /*====================
     Collection filters
   ====================*/
   initFilters: function() {
    var tags = document.querySelectorAll(selectors.tags);

    if (!tags.length) {
     return;
    }

    this.bindBackButton();

    // Set mobile top value for filters if sticky header enabled
    if (theme.config.stickyHeader) {
     this.setFilterStickyPosition();

     window.on('resize', theme.utils.debounce(500, this.setFilterStickyPosition));
    }

    document.querySelectorAll(selectors.activeTags).forEach(tag => {
     tag.addEventListener('click', this.tagClick.bind(this));
    });

    document.querySelectorAll(selectors.tagsForm).forEach(form => {
     form.addEventListener('input', this.onFormSubmit.bind(this));
    });
   },

   initPriceRange: function() {
    const priceRangeEls = document.querySelectorAll(selectors.priceRange);
    priceRangeEls.forEach((el) => new theme.PriceRange(el, {
     // onChange passes in formData
     onChange: this.renderFromFormData.bind(this),
    }));
   },

   tagClick: function(evt) {
    var el = evt.currentTarget;

    if (theme.FilterDrawer) {
     theme.FilterDrawer.close();
    }

    // Do not ajax-load collection links
    if (el.classList.contains('no-ajax')) {
     return;
    }

    evt.preventDefault();

    if (isAnimating) {
     return;
    }

    isAnimating = true;

    const parent = el.parentNode;
    const newUrl = new URL(el.href);

    this.renderActiveTag(parent, el);
    this.updateScroll(true);
    this.startLoading();
    this.renderCollectionPage(newUrl.searchParams);
   },

   onFormSubmit: function(evt) {
    var el = evt.target;

    if (theme.FilterDrawer) {
     theme.FilterDrawer.close();
    }

    // Do not ajax-load collection links
    if (el.classList.contains('no-ajax')) {
     return;
    }

    evt.preventDefault();
    if (isAnimating) {
     return;
    }

    isAnimating = true;

    const parent = el.closest('li');
    const formEl = el.closest('form');
    const formData = new FormData(formEl);

    this.renderActiveTag(parent, el);
    this.updateScroll(true);
    this.startLoading();
    this.renderFromFormData(formData);
   },

   fetchOpenCollasibleFilters: function() {
    return Array.from(
     document.querySelectorAll(
      `${selectors.sidebar} ${selectors.trigger}.${classes.isOpen}`,
     ),
    ).map(trigger => trigger.dataset.collapsibleId);
   },

   renderActiveTag: function(parent, el) {
    const textEl = parent.querySelector('.tag__text');

    if (parent.classList.contains(classes.activeTag)) {
     parent.classList.remove(classes.activeTag);
    } else {
     parent.classList.add(classes.activeTag);

     // If adding a tag, show new tag right away.
     // Otherwise, remove it before ajax finishes
     if (el.closest('li').classList.contains(classes.removeTagParent)) {
      parent.remove();
     } else {
      // Append new tag in both drawer and sidebar
      document.querySelectorAll(selectors.activeTagList).forEach(list => {
       const newTag = document.createElement('li');
       const newTagLink = document.createElement('a');
       newTag.classList.add('tag', 'tag--remove');
       newTagLink.classList.add('btn', 'btn--small');
       newTagLink.innerText = textEl.innerText;
       newTag.appendChild(newTagLink);

       list.appendChild(newTag);
      });
     }
    }
   },

   renderFromFormData: function(formData) {
    const searchParams = new URLSearchParams(formData);
    this.renderCollectionPage(searchParams);
   },

   onReplaceAjaxContent: function(newDom, section) {
    const openCollapsibleIds = this.fetchOpenCollasibleFilters();

    openCollapsibleIds.forEach(selector => {
     newDom
      .querySelectorAll(`[data-collapsible-id=${selector}]`)
      .forEach(this.openCollapsible);
    });

    var newContentEl = newDom.getElementById(section.nodeId);
    if (!newContentEl) {
     return;
    }

    document.getElementById(section.nodeId).innerHTML = newContentEl.innerHTML;
   },

   openCollapsible: function(el) {
    if (el.classList.contains(classes.filterSidebar)) {
     el.style.height = 'auto';
    }

    el.classList.add(classes.isOpen);
   },

   renderCollectionPage: function(searchParams, updateURLHash = true) {
    this.ajaxRenderer
     .renderPage(window.location.pathname, searchParams, updateURLHash)
     .then(() => {
      theme.sections.reinit('collection-grid');
      this.updateScroll(false);
      this.initPriceRange();
      theme.reinitProductGridItem();

      document.dispatchEvent(new CustomEvent('collection:reloaded'));

      isAnimating = false;
     });
   },

   bindBackButton: function() {
    // Ajax page on back button
    window.off('popstate' + this.namespace);
    window.on('popstate' + this.namespace, function(state) {
     if (state) {
      const newUrl = new URL(window.location.href);
      this.renderCollectionPage(newUrl.searchParams, false);
     }
    }.bind(this));
   },

   updateScroll: function(animate) {
    var scrollToElement = document.querySelector('[data-scroll-to]');
    var scrollTo = scrollToElement && scrollToElement.offsetTop;

    if (!theme.config.bpSmall) {
     scrollTo -= 15;
    }

    if (theme.config.stickyHeader) {
     var headerHeight = (document.querySelector('.site-header') || document.querySelector('#SiteHeader')).offsetHeight;
     scrollTo = scrollTo - headerHeight;
    }

    if (animate) {
     window.scrollTo({ top: scrollTo, behavior: 'smooth' });
    } else {
     window.scrollTo({ top: scrollTo });
    }
   },

   setFilterStickyPosition: function() {
    var headerHeight = (document.querySelector('.site-header') || document.querySelector('#SiteHeader')).offsetHeight;
    document.querySelector(selectors.filters).style.top = headerHeight + 10 + 'px';

    // Also update top position of sticky sidebar
    var stickySidebar = document.querySelector('.grid__item--sidebar');
    if (stickySidebar) {
     stickySidebar.style.top = headerHeight + 10 + 'px';
    }
   },

   forceReload: function() {
    this.init();
   },

   startLoading: function() {
    document.querySelector(selectors.collectionGrid).classList.add('unload');
   },
  });

  return Collection;
 })();


  var registerCollectionSections = function() {
    if (window.theme && theme.sections) {
      theme.sections.register('collection-header', theme.CollectionHeader);
      theme.sections.register('collection-grid', theme.Collection);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', registerCollectionSections);
  } else {
    registerCollectionSections();
  }
})();
